import "./src/styles/global.css";
import React from "react";
import { Source } from "./src/utils/source";

export const wrapRootElement = ({ element }: any) => {
  Source.init();

  return <>{element}</>;
};
